import React from 'react';

const ReferralCard = ({ title, value, subtitle, iconClass, link, isCurrency }) => (
    <div className="col-sm-6 col-lg-3 mb-3 mb-lg-5">
        <a className="card card-hover-shadow h-100 text-reset" href={`${site['app_url']}${link}`} target="_blank" rel="noopener noreferrer">
            <div className="card-body">
                <h6 className="card-subtitle mb-2">{title}</h6>
                <div className="d-flex align-items-center mb-3">
                    <div className="flex-grow-1">
                        <span className="card-title h2">
                            {isCurrency && <span>{value.currency}</span>}
                            <span>{value.amount}</span>
                            {!isCurrency && <small> Users</small>}
                        </span>
                    </div>
                    <div className="d-flex align-items-center justify-content-center rounded-circle p-3">
                        <i className={`fas ${iconClass}`}></i>
                    </div>
                </div>
                <span className="font-size-sm ml-1">{subtitle} <i className="fas fa-long-arrow-alt-right"></i></span>
            </div>
        </a>
    </div>
);

export default ReferralCard;
